import { KnownBusinessEntityContact } from "@/models/known-business-entity-contact.model.ts"
import { type Moment } from "moment"
import { ODataQueryBuilder } from "@/builder/odata-query-builder"
import { InstructionRepository } from "@/repositories/instruction-repository"

export function useInstructionAPIFunctions() {
  async function retrieveInstructionsForServiceProviderOnDate(
    serviceProvider: KnownBusinessEntityContact,
    date: Moment
  ) {
    const query = new ODataQueryBuilder()
      .eq("service_provider__id", serviceProvider.id)
      .eq("date", date.format("YYYY-MM-DD"))

    return await new InstructionRepository().getListForServiceProvider(serviceProvider, query)
  }

  async function retrieveSingleInstruction(id: string) {
    const result = await new InstructionRepository().get(id, {
      statusCodeHandlers: [
        {
          statusCode: 404,
          callback: () => {
            Promise.resolve(null)
            return true
          }
        }
      ]
    })
    return Promise.resolve(result)
  }

  return {
    retrieveInstructionsForServiceProviderOnDate,
    retrieveSingleInstruction
  }
}
